__turbopack_context__.v({
  "activeFilter": "active-filters-module-scss-module__l8Tkkq__activeFilter",
  "activeFilters": "active-filters-module-scss-module__l8Tkkq__activeFilters",
});
